import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import axios from "axios"; // For API calls
// Styles Nabavr
import Styles from "../../assets/css/NavFoot/Navbar.module.css";
// Global States Imports
import { useGlobalState } from "../../Functions/GlobalStates"; // Import the custom hook

const Navbar = () => {
  // React Router Dom Hooks
  const location = useLocation(); // Get current route info
  // Images Imports Processing
  const WebsiteLogos = require.context(
    "../../assets/images/Logos/",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const logo = WebsiteLogos("./Affiliators.png");
  // States here
  const [BlogsDisplay, setBlogsDisplay] = useState("none");
  const [NavBlogArrowRotate, setNavBlogArrowRotate] = useState("0deg");
  const [NavBlogArrowPosition, setNavBlogArrowPosition] = useState("0%");
  const [overlayVisible, setOverlayVisible] = useState(false); // State for overlay visibility
  const [isWithinRange, setIsWithinRange] = useState(false);
  const [isWithinRange600, setIsWithinRange600] = useState(false);
  const [isRotated, setIsRotated] = useState(false);
  // React useRefs hooks
  // const currentWidthHeight = useRef({ height: 0 });
  const AllcurrentWidthHeight = useRef({ height: 0 });

  // Global States
  const {
    DropMenu,
    setDropMenuVisibility,
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    // PagesWidthHeight,
    // setPagesWidthHeight,
    AllPagesWidthHeight,
    setAllPagesWidthHeight,
  } = useGlobalState();

  const NavBlogArrowStyles = {
    position: "relative",
    left: `${NavBlogArrowPosition}`,
    transition: "all .3s",
    transform: `rotate(${NavBlogArrowRotate})`,
  };

  // Show Bars when navbar is hidden
  useEffect(() => {
    const ShowBarsIfNavbarHidden = () => {
      const width = window.innerWidth;
      if (width >= 0 && width <= 600) {
        setIsWithinRange600(true);
      } else {
        setIsWithinRange600(false);
      }
    };
    ShowBarsIfNavbarHidden(); // initial run on mount

    window.addEventListener("resize", ShowBarsIfNavbarHidden);

    return () => {
      window.removeEventListener("resize", ShowBarsIfNavbarHidden);
    };
  }, []);

  useEffect(() => {
    const UpdateWidthHeightOfPages = () => {
      // console.log("Current height:", AllPagesWidthHeight.height);
      const newHeight = AllPagesWidthHeight.height; // Get current height

      if (AllcurrentWidthHeight.current.height !== newHeight) {
        AllcurrentWidthHeight.current.height = newHeight;
        // console.log("Height is not equal and condition is true");

        // Update state only if the value actually changes
        setAllPagesWidthHeight((prev) => {
          if (prev.height === newHeight) {
            // console.log("Skipping update - Same height:", newHeight);
            return prev;
          }
          // console.log("Updating height to:", newHeight);
          return { ...prev, height: parseFloat(newHeight.toFixed(1)) };
        });
      }
    };

    UpdateWidthHeightOfPages(); // Initial run
    window.addEventListener("resize", UpdateWidthHeightOfPages);

    return () => {
      window.removeEventListener("resize", UpdateWidthHeightOfPages);
    };
  }, [location.pathname]); // Removed `AllPagesWidthHeight.height` to prevent infinite loop

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= 0 && width <= 800) {
        if (DropMenu) {
          setBlogsDisplay("none"); // Hide the blogs menu when clicking outside
          setNavBlogArrowRotate("0deg");
          setNavBlogArrowPosition("0%");
          setOverlayVisible(false); // Hide the overlay when clicking outside
        }
        setIsWithinRange(true); // Update state when width is within range
      } else {
        setIsWithinRange(false); // Update state when width is out of range
      }
    };

    // Call the function initially to set the state based on the current width
    handleResize();

    // Add the resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [DropMenu]);

  useEffect(() => {
    if (isWithinRange) {
      setIsRotated((prev) => !prev); // Toggle the rotation state
    } else {
      setIsRotated(false); // Toggle the rotation state
    }
  }, [isWithinRange]); // This will only run when isWithinRange changes

  // Prevent Window Click Event to Stop Menu Closing when Clicked Inside
  const preventMenuHide = (e) => {
    e.stopPropagation(); // Prevents triggering the window click event
  };

  // On Click Transition
  const HandleClickDropMenuBars = (e) => {
    e.stopPropagation(); // Prevents triggering the window click event
    setDropMenuVisibility((prev) => !prev); // sidebar DropMenu
    // console.log(DontAllow);
    if (DontAllow && isWithinRange) {
      setCheckPage((prev) => !prev); // Navbar DropMenu
    }

    if (BlogsDisplay === "flex") {
      setBlogsDisplay("none"); // Hide the blogs menu when clicking outside
      setNavBlogArrowRotate("0deg");
      setNavBlogArrowPosition("0%");
      setOverlayVisible(false); // Hide the overlay when clicking outside
    }
  };

  const toggleBlogsDisplay = (e) => {
    e.stopPropagation(); // Prevents triggering the window click event
    setBlogsDisplay((prev) => (prev === "none" ? "flex" : "none"));
    setNavBlogArrowRotate((prev) => (prev === "0deg" ? "90deg" : "0deg"));
    setNavBlogArrowPosition((prev) => (prev === "0%" ? "3%" : "0%"));
    setOverlayVisible((prev) => !prev); // Toggle the overlay visibility when clicked
    if (DropMenu && isWithinRange) {
      setDropMenuVisibility(false); // hide the sidebar when blogs display is updating to flex
    }
    if (!CheckPage && isWithinRange) {
      setCheckPage(true); // Navbar DropMenu
    }
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setBlogsDisplay("none"); // Hide the blogs menu when clicking outside
      setNavBlogArrowRotate("0deg");
      setNavBlogArrowPosition("0%");
      setOverlayVisible(false); // Hide the overlay when clicking outside
      if (DropMenu && isWithinRange) {
        setDropMenuVisibility(false); // hide the sidebar when blogs display is flex
      }
      setCheckPage(true);
      if (!isWithinRange600) {
        setBlogsDisplay("none"); // Hide the blogs menu when clicking outside
        setOverlayVisible(false); // hide the overlay
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [DropMenu, isWithinRange]); // Re-run effect on changes in either DropMenu or isWithinRange

  // Reset Display to hide blogs menu On Click For Better Experience........../////////////////////............./////////////////////////
  const ResetBlogsDisplay = (e) => {
    if (BlogsDisplay === "flex") {
      e.stopPropagation(); // Prevents triggering the window click event
      setBlogsDisplay("none");
      setNavBlogArrowRotate("0deg");
      setNavBlogArrowPosition("0%");
      setOverlayVisible(false); // hide the overlay visibility when clicked
    }
  };

  // NavbarDropNenu Section2 Ratings Stars Code ///////////////////////////////////////////////////////////////////////////////// .....................
  const [userRating, setUserRating] = useState(0);
  const [averageRating, setAverageRating] = useState(5);
  const [hasRated, setHasRated] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRatings = async () => {
      try {
        const response = await axios.get(
          "https://affiliators.netlify.app/.netlify/functions/server/api/ratings"
        ); // Fetch ratings from backend
        setAverageRating(response.data.averageRating || averageRating);
        
        const savedRating = localStorage.getItem("userRating");
        if (savedRating) {
          setUserRating(Number(savedRating));
          setHasRated(true);
        }
      } catch (error) {
        console.error("Error fetching ratings:", error.message);
        setError("Failed to load ratings. Please try again later.");
      }
    };

    fetchRatings();

  }, []);

  const handleRating = async (newRating) => {
    setUserRating(newRating);
    try {
      const response = await axios.post(
        "https://affiliators.netlify.app/.netlify/functions/server/api/ratings",
        { rating: newRating },
        {
          headers: {
            "Content-Type": "application/json", // Optional, but explicitly setting it
          },
        }
      );
      setAverageRating(response.data.updatedAverage || averageRating); // RealTime Updating

      localStorage.setItem("userRating", newRating);
      setHasRated(true);
      // alert("Thank you for rating!");
    } catch (error) {
      console.error("Error submitting rating:", error.message);
      alert("Failed to submit your rating. Please try again later.");
    }
  };

  // This function returns stars that then presented in the next return
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => {
      const fillPercentage = Math.min(Math.max(rating - index, 0), 1) * 100; // Calculate fill percentage for each star

      return (
        <span
          key={index}
          style={{
            position: "relative",
            color: "#ccc",
          }}
        >
          <span
            style={{
              position: "absolute",
              color: "#ffd700",
              overflow: "hidden",
              clipPath: `inset(0 ${100 - fillPercentage}% 0 0)`, // Clip the star based on the percentage filled
            }}
          >
            ★
          </span>
          ★
        </span>
      );
    });
  };

  return (
    <>
      <div
        style={{
          height:
            AllPagesWidthHeight.height === 0
              ? "fit-content"
              : `${AllPagesWidthHeight.height}px`,
        }}
        className={Styles.NavbarContainer}
      >
        <nav className={Styles.Navbar}>
          <div className={Styles.NavbarLinks}>
            <img
              src={logo}
              alt="Speed"
            // style={{
            //   filter: "invert(100%)",
            // }}
            />
            <NavLink
              className={({ isActive }) =>
                isActive ? Styles.activeLink : Styles.inactiveLink
              }
              to="/"
              end
            >
              Home
            </NavLink>
            <div onClick={toggleBlogsDisplay}>
              Blogs
              <span
                style={NavBlogArrowStyles}
                className={Styles.NavbarBlogRotate90}
              >
                &nbsp;&#8250;
              </span>
            </div>
            <NavLink
              className={({ isActive }) =>
                isActive ? Styles.activeLink : Styles.inactiveLink
              }
              to="/about-us"
              end
            >
              About Us
            </NavLink>
            {isWithinRange === false ? (
              <>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                  to="/services"
                  end
                >
                  Services
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                  to="/privacy-policy"
                  end
                >
                  Privacy Policy
                </NavLink>
              </>
            ) : (
              <></>
            )}
          </div>
          <div className={Styles.NavbarSupportLinks}>
            {isWithinRange === false ? (
              <>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? Styles.activeLink : Styles.inactiveLink
                  }
                  to="/customer-support"
                  end
                >
                  &#9742; Customer Support &#x2764;
                </NavLink>
              </>
            ) : (
              <>
                <div
                  onClick={HandleClickDropMenuBars}
                  className={Styles.NavbarBlogsSidebarDropMenuContainer}
                >
                  <div
                    style={{
                      transform: isRotated
                        ? "rotate(90deg) scale(1) translateX(0px) translateY(0px)"
                        : "rotate(0deg) scale(.2) translateX(0vw) translateY(40vw)",
                    }}
                    className={Styles.NavbarBlogsSidebarDropMenuBarsContainer}
                  >
                    <h1 className={Styles.NavbarBlogsSidebarDropMenuBar1}>|</h1>
                    <h1 className={Styles.NavbarBlogsSidebarDropMenuBar2}>|</h1>
                    <h1 className={Styles.NavbarBlogsSidebarDropMenuBar3}>|</h1>
                  </div>
                </div>
              </>
            )}
          </div>
        </nav>
        {/* Overlay Div */}
        {overlayVisible && <div className={Styles.WindowOverlay} />}
        {/* Blogs Menu */}
        <div
          onClick={preventMenuHide}
          style={{ display: `${BlogsDisplay}` }}
          className={Styles.NavbarBlogsMenuContainer}
        >
          <div className={Styles.NavbarBlogsMenuWeb}>
            <h1>PROBLEM SOLVING </h1>
            <div className={Styles.NavbarBlogsMenuWebLinks}>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to={"/problemsolving/npmerrors"}
                end
              >
                Npm Errors
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/problemsolving/slowlaptop"
                end
              >
                Slow Laptop
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/problemsolving/hostingdomainsolution"
                end
              >
                Hosting & Domain Solutions
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/problemsolving/mobileresponsiveness"
                end
              >
                Mobile Responsiveness
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/problemsolving/ecommercesolutions"
                end
              >
                E-Commerce Solutions
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/problemsolving/securitysolutions"
                end
              >
                Security Solutions
              </NavLink>
            </div>
          </div>
          <div className={Styles.NavbarBlogsMenuGraphic}>
            <h1>REALLIFE GADGETS</h1>
            <div className={Styles.NavbarBlogsMenuGraphicLinks}>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/nightsleepmask"
                end
              >
                Night Sleep Mask
              </NavLink>

              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/electricspinscrubber"
                end
              >
                Electric Spin Scrubber
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/chargeablepolesawchainsaw"
                end
              >
                ChargeablePoleSaw ChainSaw
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/pushupboard"
                end
              >
                Push Up Board
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/rechargeablespotlight"
                end
              >
                RechargeableSpotlight
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/reallifegadgets/smartclock"
                end
              >
                Smart Clock
              </NavLink>
            </div>
          </div>
          <div className={Styles.NavbarBlogsMenuSeo}>
            <h1>PERFECT GIFTS GUIDE</h1>
            <div className={Styles.NavbarBlogsMenuSeoLinks}>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/goldplatedflower"
                end
              >
                Gold Plated Flower
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/musclemassager"
                end
              >
                Muscle Massager
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/advanceddrone"
                end
              >
                Advanced Drone
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/summerdress"
                end
              >
                Summer Dress
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/fleecebalaclava"
                end
              >
                Fleece Balaclava
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/PerfectGiftsGuide/oled"
                end
              >
                OLED
              </NavLink>
            </div>
          </div>
          <div className={Styles.NavbarBlogsMenuLifestyle}>
            <h1>INFORMATIONAL TOPICS</h1>
            <div className={Styles.NavbarBlogsMenuLifestyleLinks}>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Health & Wellness
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Career Development
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Productivity & Time Management
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Self-Improvement
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Motivation & Inspiration
              </NavLink>
              <NavLink
                onClick={ResetBlogsDisplay}
                className={({ isActive }) =>
                  isActive ? Styles.activeLink : Styles.inactiveLink
                }
                to="/comingsoon"
                end
              >
                Financial Growth
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      {!CheckPage && isWithinRange && (
        <div
          style={{ height: `${AllPagesWidthHeight.height}px` }}
          onClick={preventMenuHide}
          className={Styles.NavbarDropMenuPagesAverageStarsWrapper}
        >
          <div className={Styles.NavbarDropMenuPagesAverageStarsContainer}>
            <section className={Styles.NavbarDropMenuPagesSection1}>
              <h1>Pages</h1>
              <NavLink to="/">Home</NavLink>
              <NavLink onClick={toggleBlogsDisplay} to="/">
                Blogs
              </NavLink>
              <NavLink to="/about-us">About Us</NavLink>
              <NavLink to="/services">Services</NavLink>
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
              <NavLink to="/customer-support">
                &#9742; Customer Support &#x2764;
              </NavLink>
            </section>
            {/* Rating Section */}
            <section className={Styles.NavbarDropMenuSection2RatingsContainer}>
              {error && (
                <div style={{ color: "red" }} className={Styles.ErrorMessage}>
                  {error}
                </div>
              )}
              {!hasRated ? (
                <>
                  <div
                    className={
                      Styles.NavbarDropMenuSection2RatingsStarsGrayContainer
                    }
                  >
                    <h2>Rate This Blog</h2>
                    <div
                      className={
                        Styles.NavbarDropMenuSection2GrayStarsContainer
                      }
                    >
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          onClick={() => handleRating(star)}
                          style={{
                            color: star <= userRating ? "#ffd700" : "#ccc", // Highlight stars
                          }}
                          // Hover effect to show highlighted stars
                          onMouseEnter={() => setUserRating(star)}
                          onMouseLeave={() => !hasRated && setUserRating(0)}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                  </div>
                </>
              ) : (
                <div
                  className={
                    Styles.NavbarDropMenuSection2ThanksUserRatingsContainer
                  }
                >
                  <p style={{ color: "black" }}>
                    Your Rating: &nbsp;
                    <span style={{ color: "red" }}>{userRating} Stars</span>
                  </p>
                  <p style={{ color: "black" }}>Thank you for rating Us💖</p>
                </div>
              )}

              {/* Show average rating after user has submitted their rating */}
              {hasRated && (
                <>
                  <div
                    className={
                      Styles.NavbarDropMenuSection2AllUsersRatingsStarsContainer
                    }
                  >
                    <div
                      className={
                        Styles.NavbarDropMenuSection2AllUsersStarsContainer
                      }
                    >
                      {renderStars(averageRating)}{" "}
                      {/* Display average rating with dynamic gradients */}
                    </div>
                    <p>Average Rating: {averageRating.toFixed(1)} Stars</p>
                  </div>
                </>
              )}
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
